/** A person's own presence: the statuses they can pick, and the automatic ones the server can also report. */
export type PresenceStatus =
  | 'available'
  | 'busy'
  | 'dnd'
  | 'be_right_back'
  | 'away'
  | 'offline';

/**
 * Every status a person can be shown in. The two extras are never picked by
 * hand: they come from the automatic statuses in Preferences > Availability.
 */
export type ResolvedPresenceStatus = PresenceStatus | 'in_meeting' | 'on_site';

export interface ManualPresenceEntry {
  status: PresenceStatus;
  /** ISO string, or null if the override never auto-expires. */
  expiresAt: string | null;
  setAt: string;
}

export const PRESENCE_LABELS: Record<ResolvedPresenceStatus, string> = {
  available:     'Available',
  busy:          'Busy',
  dnd:           'Do Not Disturb',
  be_right_back: 'Be Right Back',
  away:          'Away',
  offline:       'Appear Offline',
  in_meeting:    'In a Meeting',
  on_site:       'On Site',
};
